export function buildDataSource({ base, showRootDraft, childDrafts }) {
  let result = base || [];

  // корневой черновик наверху
  if (showRootDraft) {
    result = [
      {
        _id: "__root_draft__",
        __isRootDraft: true,
        name: "",
        parent_id: null,
        children: [],
      },
      ...result,
    ];
  }

  // дочерние черновики в каждой группе (сверху её детей)
  const withChildDrafts = result.map((g) => {
    const draftName = childDrafts[g._id];
    if (draftName === undefined) return g;

    const draftRow = {
      _id: `__child_draft__${g._id}`,
      __isChildDraft: true,
      name: "",
      parent_id: g._id,
    };

    return { ...g, children: [draftRow, ...(g.children || [])] };
  });

  return withChildDrafts;
}
